import styled from 'styled-components';

export const StyledLegacyGameActivity = styled.div`
  width: 100%;
  height: 100%;

  :focus-visible {
    outline: none;
    border: none;
  }

  .aspect-ratio {
    display: flex;
    flex-direction: column;

    .spinner-wrapper {
      width: 100%;
      height: 100%;
      border: 0;
      background: #000;
      border-radius: 5px;
      overflow: hidden;

      .ant-spin-container {
        width: 100%;
        height: 100%;
        border: 0;

        iframe {
          width: 100%;
          height: 100%;
          max-height: var(--appheight) !important;
          border: 0;
        }
      }
    }
  }

  &.fullscreen {
    .aspect-ratio .spinner-wrapper {
      border-radius: 0;
      border: none;
    }
  }
`;
